export type ConfidenceDetail = { label: string; colorClass: string };

// Prediction-confidence badge styling, shared by the species tables/modals.
export const confidenceDetails: Record<string, ConfidenceDetail> = {
    low: { label: 'Low', colorClass: 'text-xs text-black font-normal bg-red-0 hover:bg-red-0 border border-red-20' },
    medium: { label: 'Medium', colorClass: 'text-xs text-black font-normal bg-orange-0 hover:bg-orange-0 border border-orange-20' },
    high: { label: 'High', colorClass: 'text-xs text-black font-normal bg-green-0 hover:bg-green-0 border border-green-20' },
};

// Case-insensitive lookup; falls back to `low` for unknown/missing levels.
export const getConfidenceDetail = (level?: string | null): ConfidenceDetail =>
    confidenceDetails[level?.toLowerCase() ?? ''] ?? confidenceDetails.low;
